<template >
    <div class="pages memberList">
        <div class="f1 mb-30">
            <div class="d1">
                积木云提供全渠道全触点会员数据与会员事件分析
            </div>
            <div class="d2">
                <div class="text">
                  <p> 昨日系统中新增<span>100</span>个客户、其中新增客户 <span>10</span>个关注公众号。且新增回流客户<span>100</span>个</p>
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="f2 mb-30">
            <div class="bf" :class="types==1 ? 'active' : ''" @click="chagef2(1)">
                <img v-show="types!=1" src="../../assets/images/newIcon/vip_customer_icon2.png" alt="">
                <img v-show="types==1" src="../../assets/images/newIcon/vip_customer_icon.png" alt="">
                <p>
                    <span>全部客户</span>
                    <span>36,254</span>
                </p>
            </div>
            <div class="bf" :class="types==2 ? 'active' : ''"  @click="chagef2(2)">
                <img v-show="types!=2" src="../../assets/images/newIcon/vip_addcustomer_icon.png" alt="">
                <img v-show="types==2" src="../../assets/images/newIcon/vip_shangshengwhite_icon.png" alt="">
                <p>
                    <span>新增客户</span>
                    <span>36,254</span>
                </p>
            </div>
            <div class="bf" :class="types==3 ? 'active' : ''"  @click="chagef2(3)">
                <img v-show="types!=3" src="../../assets/images/newIcon/vip_lost_icon.png" alt="">
                <img v-show="types==3" src="../../assets/images/newIcon/vip_lostwhite_icon.png" alt="">
                <p>
                    <span>流失客户</span>
                    <span>36,254</span>
                </p>
            </div>
            <div class="bf" :class="types==4 ? 'active' : ''"  @click="chagef2(4)">
                <img v-show="types!=4" src="../../assets/images/newIcon/vip_public_icon.png" alt="">
                <img v-show="types==4" src="../../assets/images/newIcon/vip_publicwhite_icon.png" alt="">
                <p>
                    <span>公众号客户</span>
                    <span>36,254</span>
                </p>
            </div>
        </div>
        <div class="f3">
            <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="搜索客户：">
                            <el-input
                            class="iptRdio"
                            placeholder="请搜索客户昵称/手机号"
                            suffix-icon="el-icon-search"
                            v-model="query.keyword_search"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="会员来源：">
                            <span style=" position: relative;"  >
                                <span @click="showSource">
                                    <el-input
                                    class="iptRdio"
                                    placeholder=""
                                    suffix-icon="el-icon-arrow-down"
                                    ></el-input>
                                </span>
                                <p class="sources">
                                    <template v-if="screenWidth<1366">
                                         <span v-for="(item,index) in sourceList.slice(0,1)" :key="index">{{item.name}} <i @click="delSource(index)" class="el-icon-close"></i></span>
                                    </template>
                                    <template v-else>
                                         <span v-for="(item,index) in sourceList.slice(0,2)" :key="index">{{item.name}} <i @click="delSource(index)" class="el-icon-close"></i></span>
                                    </template>
                                   
                                    <el-popover
                                    v-if="sourceList.length"
                                    placement="bottom"
                                    width="300"
                                    trigger="click">
                                    <p class="sources2">
                                    <span v-for="(item,index) in sourceList" :key="index">自然进入 <i @click="delSource(index)" class="el-icon-close"></i></span>
                                    </p>
                                    <span slot="reference">...</span>
                                    </el-popover>
                                </p>
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="注册时间：">
                            <el-date-picker
                            v-model="time"
                            type="daterange"
                            class="times"
                            range-separator="→"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <div style="text-align: right;display:flex;justify-content: flex-end;">
                            <el-button @click="reset"  class="reson" type="primary" round icon="el-icon-refresh-right">重置</el-button>
                            <el-button type="text" v-if="showTypes==2" @click="showTypes=1">收起 <i class="el-icon-arrow-up icons"></i></el-button>
                            <el-button type="text" v-if="showTypes==1" @click="showTypes=2">展开 <i class="el-icon-arrow-down icons"></i></el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-show="showTypes==2" :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="会员标签：">
                            <span @click="showPopup(4)">
                                <el-input
                                class="iptRdio"
                                placeholder="请选择会员标签"
                                suffix-icon="el-icon-arrow-down"
                                v-model="query.label_val"
                                ></el-input>
                            </span>
                            
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="积分筛选：">
                        <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click">
                        <div class="popContent">
                            <p>请输入积分分值范围</p>
                            <div>
                                <el-input
                                class="iptRdio"
                                placeholder="请输入分值"
                                v-model="query.jf_val"
                                ></el-input>
                                <span>~</span>
                                <el-input
                                class="iptRdio"
                                placeholder="请输入分值"
                                v-model="query.jf_val"
                                ></el-input>
                            </div>
                        </div>
                        <el-input
                            readonly
                            class="iptRdio"
                            slot="reference"
                            placeholder="请输入分值范围"
                            v-model="query.jf_val"
                            ></el-input>
                        </el-popover>
                           
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="参与活动：">
                            <el-select class="iptRdio" v-model="participateValue" placeholder="请选择">
                                <el-option
                                v-for="item in participate"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" v-if="participateValue==1">
                        <div style="text-align: right;">
                            <el-input
                            class="iptRdio"
                            style="width:100%;"
                            placeholder="请输入参与次数"
                            v-model="query.keyword_search"
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-show="showTypes==2" :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="优惠券领取：">
                            <el-select class="iptRdio" v-model="showVal" placeholder="请选择">
                                <el-option
                                v-for="item in shows"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="优惠券使用：">
                            <el-select class="iptRdio" v-model="showVal2" placeholder="请选择">
                                <el-option
                                v-for="item in shows"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="活跃时间：">
                            <el-date-picker
                            v-model="time"
                            type="daterange"
                            class="times"
                            range-separator="→"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                    </el-col>
                </el-row>
                <el-row v-show="showTypes==2" :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="会员等级：">
                             <el-select class="iptRdio" v-model="value" placeholder="请选择">
                                <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <span @click="showPopup(1)">
                                <el-input
                                class="iptRdio"
                                readonly
                                placeholder="请选择会员等级"
                                suffix-icon="el-icon-arrow-down"
                                v-model="query.keyword_search"
                                ></el-input>
                            </span> -->
                           
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="消费金额：">
                            <!-- <el-input
                            class="iptRdio"
                            placeholder="分值范围"
                            v-model="query.keyword_search"
                            ></el-input>-->
                             <el-popover
                            placement="bottom"
                            width="300"
                            trigger="click"> 
                            <div class="popContent">
                                <p>请输入金额范围</p>
                                <div>
                                    <el-input
                                    class="iptRdio"
                                    placeholder="请输入金额"
                                    v-model="query.je_val"
                                    ></el-input>
                                    <span>~</span>
                                    <el-input
                                    class="iptRdio"
                                    placeholder="请输入金额"
                                    v-model="query.je_val"
                                    ></el-input>
                                </div>
                            </div>
                            <el-input
                                readonly
                                class="iptRdio"
                                slot="reference"
                                placeholder="请选择金额范围"
                                v-model="query.je_val"
                                ></el-input>
                            </el-popover>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item class="formItem formItem2" label="群组筛选：">
                             <el-select class="iptRdio" v-model="value" placeholder="请选择群组
                            ">
                                <el-option
                                v-for="item in options3"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                    </el-col>
                </el-row>
                <el-row v-show="showTypes==2" :gutter="20">
                    <el-col :span="6">
                        <el-form-item class="formItem" label="业务系统：">
                            <el-select class="iptRdio" v-model="value2" placeholder="请选择业务系统
                            ">
                                <el-option
                                v-for="item in options3"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="f4 bf">
            <div class="d1">
                <p>共<span>{{total}}</span>条 已选中<span>0</span>条</p>
                <p>
                    <el-button @click="showPopup(3)" plain class="kh-btn"><img src="../../assets/images/newIcon/label_customer_icon.png" alt=""> 批量打标签</el-button>
                    <el-button @click="showExport" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/vip_daochu_icon.png" alt=""> 会员导出</el-button>
                </p>
            </div>
            <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center'}"
                style="width: 100%;"
                :cell-style="cellStyle"
                >
                <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                prop="number"
                label="手机号"
                >
                </el-table-column>
                <el-table-column
                prop="number"
                label="来源"
                
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="ID"
               >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="注册时间"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员标签"
                width="240"
                >
                    <template slot-scope="scope">
                        <div class="labelLi">
                            <p>标签111</p>
                            <p>标签222</p>
                            <el-popover
                            placement="bottom"
                            width="200"
                            trigger="click">
                            <div class="labelAll">
                                <el-tag>标签一</el-tag>
                                <el-tag>标签一</el-tag>
                            </div>
                            <span class="s" slot="reference">...</span>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员等级"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="会员积分"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width='200'
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="goDetials">详情</el-button>
                        <el-button  @click="showPopup(4)" type="text">添加标签</el-button>
                        <span style="padding-right:10px;"></span>
                        <el-popover
                            placement="bottom"
                            trigger="click">
                            <div class="ged">
                                <p @click="showPopup(1)">修改等级</p>
                                <p  @click="showPopup(2)">修改积分</p>
                            </div>
                           <el-button slot="reference"  type="text">更多</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <customer-popup @doSelect='doSelect' ref="customerPopup"></customer-popup>
        <export-customer ref="exportCustomer"></export-customer>
        <member-source ref="memberSource"></member-source>
    </div>
</template>
<script>
import exportCustomer from './components/exportCustomer.vue'
import memberSource from './components/memberSource.vue'
const QUERY={
    keyword_search:"",
    jf_val:"",
    label_val:"",
    je_val:"",
    page_index:"",
    page_size: 10,
}
export default {
    data() {
        return {
            screenWidth: document.body.clientWidth,     // 屏幕宽
            query:JSON.parse(JSON.stringify(QUERY)),
            types:1,
            showTypes:1,
            participateValue:"",
            time:"",
            value2:"",
            total:90,
            sourceList:[
                {name:"自然进入1",id:1},
                {name:"自然进入2",id:2},
                {name:"自然进入3",id:3},
            ],
            participate:[
                {
                    value: '1',
                    label: '参与活动'
                },
                {
                    value: '2',
                    label: '从未参与'
                },
            ],
            showVal:"",
            showVal2:"",
            shows:[
                {
                    value: '1',
                    label: '是'
                },
                {
                    value: '2',
                    label: '否'
                },
            ],
            options3:[],
            options: [{
            value: '选项1',
            label: '全部'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }, {
            value: '选项3',
            label: '颐安中台'
            }, {
            value: '选项4',
            label: '业务系统3'
            }],
            options2: [{
            value: '选项1',
            label: '青铜会员'
            }, {
            value: '选项2',
            label: '黄金会员'
            }],
            options3: [{
            value: '选项1',
            label: '小橘帮帮'
            }, {
            value: '选项2',
            label: '颐安中台'
            }],
            tableData3: [{
                name: '小程序',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '小红书',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                },{
                name: '移动端',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
            }],
            value: ''
        }
    },
    components:{exportCustomer,memberSource},
    mounted(){
        console.log(this.screenWidth,111111111)
    },
    methods:{
        reset(){
            this.query=JSON.parse(JSON.stringify(QUERY))
        },
        delSource(i){
            this.sourceList.splice(i,1);
        },
        goDetials(){
            this.$router.push({name:'memberDetail',query:{id:111}})
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            // console.log(rowIndex,columnIndex,11111);
            if (columnIndex>1) {
                return `font-size:12px;textAlign:center`;
            } else {
                return 'textAlign:center'
            }
        },
        doSelect(data){
            console.log(data,111)
        },
        showSource(){
            this.$refs.memberSource.show();
        },
        showPopup(type){
            this.$refs.customerPopup.show(type);
        },
        showExport(){
            this.$refs.exportCustomer.show();
        },
        chagef2(type){
            this.types=type;
        },
        handleSizeChange(val) {
        this.query.page_size = val;
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
        },
    }
}
</script>
<style>
    .el-popover{
        min-width: 80px !important;
    }
    /* .el-date-range-picker{
        width:470px !important;
    } */
</style>
<style lang="less" scoped>
    .sources2{
        // position: absolute;
        // top: -3px;
        // left: 12px;
        span{
            // position: relative;
            display: inline-block;
            margin-right:6px;
            // width: 45px;
            background: #327EFF;
            border-radius: 15px;
            color:#fff;
            padding:0 6px;
            
            padding-right: 18px;
            font-size: 12px;
            line-height: 24px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            // &:last-child{
            //     padding:0 2px;
            //     width:40px;
            //     height:24px;
            //     text-align: center;
            //     font-size:16px;
            //     font-weight: bold;
            // }
            i{
                // position: absolute;
                top: 6px;
                right:10px;
            }
        }
    }
    .memberList{
       .sources{
            position: absolute;
            top: -3px;
            left: 12px;
            span{
                position: relative;
                display: inline-block;
                margin-right:6px;
                width: 45px;
                background: #327EFF;
                border-radius: 15px;
                color:#fff;
                padding:0 6px;
                
                padding-right: 18px;
                font-size: 12px;
                line-height: 24px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                &:last-child{
                    padding:0 2px;
                    width:40px;
                    height:24px;
                    text-align: center;
                    font-size:16px;
                    font-weight: bold;
                }
                i{
                    position: absolute;
                    top: 6px;
                    right:10px;
                }
            }
        }
        .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 6%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 21px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
                letter-spacing: 7px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
        }
        .f2{
            display: flex;
            justify-content: space-between;
            div{
                width:23%;
                height: 150px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding:30px 0px;
                box-sizing: border-box;
                border-radius: 8px;
                img{
                    width:66px;
                    height:66px;
                }
                p{
                    margin-left:15px;
                    span{
                        display: block;
                        &:first-child{
                            font-size: 16px;
                            font-weight: 400;
                            color: #333333;
                        }
                        &:last-child{
                            margin-top:10px;
                            font-size: 30px;
                            font-weight: bold;
                            color: #333333;
                            line-height: 35px;
                        }
                    }
                }
            }
            .active{
                background: #327EFF;
                span{
                    color:#fff !important;
                }
            }
        }
        
        .f3{
           /deep/ .el-col-3{
               width:13.5%;
           }
           /deep/ .el-col-6{
               width:28%;
           }
            .icons{
                padding: 2px;
                margin-left:10px;
                color: rgb(255, 255, 255);
                background: rgb(46, 108, 246);
                border-radius: 50%;
            }
            .reson.el-button{
                background: #2E6CF6;
            }
           
            .times.el-input__inner{
                border-radius: 30px;
                width:100%;
                height:38px;
                .el-range-separator{
                    font-size:16px;
                    color:#ccc;
                    line-height: 28px;
                }
            }
            /deep/ .formItem.el-form-item{
                width:100%;
            }
            /deep/ .el-select{
                width: 100%;
            }
            /deep/ .formItem2  .el-form-item__content{
                // width:66%;
            }
            /deep/ .el-form-item__content{
                width:calc(100% - 100px);
            }
        }
        /deep/ .el-button{
            font-size:12px;
        }
        .f4{
            border-radius: 8px;
            .d1{
                padding:15px;
                p{
                    &:first-child{
                        font-size: 16px;
                        font-weight: 500;
                        color: #333940;
                        span{
                            color:#327EFF;
                        }
                    }
                    
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                .kh-btn.el-button{
                    border-radius: 15px;
                    border: 1px solid #327EFF;
                    color:#327EFF;
                }
            }
            /deep/ .el-checkbox__inner{
                border-radius: 15px;
            }
            .labelLi{
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    margin-right:8px;
                    display: inline-block;
                    width:40px;
                    padding:0px 8px;
                    background: rgba(211, 236, 255, 0.4);
                    border-radius: 15px;
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // &:last-child{
                    //     padding:0 4px;
                    //     text-align: center;
                    //     // border:0;
                    //     // background:#fff;
                    // }
                    
                }
                .s{
                    background: rgba(211, 236, 255, 0.4);
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    padding: 2px 10px;
                    color: #0091FF;
                    border-radius: 18px;
                    width: auto;
                }
            }
        }
    }
    .page{
        /deep/ .el-pagination .btn-prev{
            margin-right:10px;
        }
        /deep/ .el-pagination .btn-next{
            margin-left:10px;
        }
    }
    /deep/ .el-range-editor--mini .el-range-separator{
        font-size: 16px;
        color: #ccc;
        line-height: 28px;
    }
    .ged{
        p{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            &:first-child{
                color:#327EFF;
                padding-bottom:8px;
                border-bottom:1px solid #EFEFEF;
            }
            &:last-child{
                padding-top:8px;
            }
        }
    }
    .popContent{
        padding:15px;
        p{
            margin-bottom:15px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
        }
        div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .iptRdio{
                width:115px;
            }
            span{
                font-size: 24px;
                font-weight: 400;
                color: #ccc;
                line-height: 20px;
            }
            input{
                border-radius: 30px;
                // width:115px !important;
            }
        }
    }
     /deep/ .iptRdio .el-input__inner{
        border-radius: 30px;
        height:38px;
    }
</style>